import React, { useContext } from 'react';
import Analytics from '../../../../client/analytics';

function EmbeddedAnalyticsWrapper(commonProperties = {}) {
  return {
    ...Analytics,

    track: (event, properties, options, callback) => {
      Analytics.track(
        event,
        { ...commonProperties, ...properties },
        options,
        callback
      );
    },
  };
}

const AnalyticsContext = React.createContext(Analytics);

function AnalyticsProvider({
  storeId,
  storeName,
  isSandbox,
  checkoutType,
  children,
}) {
  const wrapper = EmbeddedAnalyticsWrapper({
    storeId,
    storeName,
    isSandbox,
    checkoutType,
  });
  return (
    <AnalyticsContext.Provider value={wrapper}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export function useAnalytics() {
  return useContext(AnalyticsContext);
}

export default AnalyticsProvider;
